<template>
  <section
    v-if="tab === 5"
    class="user-information p-3 bg-white box-shaddow20 position-relative overflow-auto border-r-10"
  >
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <WalletIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">کیف پول</h4>
      </div>
      <div>
        <button
          data-toggle="modal"
          data-target="#depositModal"
          class="border-r-10 bg-primary py-2 px-3 ml-2"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.1074 4.68785H15.1274C14.9849 4.48535 14.8349 4.29785 14.6774 4.11035L14.1074 4.68785Z"
              fill="white"
            />
            <path
              d="M13.89 3.31523C13.7025 3.15773 13.515 3.00773 13.3125 2.86523V3.88523L13.89 3.31523Z"
              fill="white"
            />
            <path
              d="M14.6846 4.11008L16.8971 1.89758C17.1146 1.68008 17.1146 1.32008 16.8971 1.10258C16.6796 0.885078 16.3196 0.885078 16.1021 1.10258L13.8896 3.31508C14.1746 3.56258 14.4371 3.83258 14.6846 4.11008Z"
              fill="white"
            />
            <path
              d="M13.3128 2.25C13.3128 1.9425 13.0578 1.6875 12.7503 1.6875C12.4503 1.6875 12.2103 1.9275 12.1953 2.22C12.5853 2.4075 12.9603 2.6175 13.3128 2.865V2.25Z"
              fill="white"
            />
            <path
              d="M16.3129 5.25C16.3129 4.9425 16.0579 4.6875 15.7504 4.6875H15.1279C15.3754 5.04 15.5929 5.415 15.7729 5.805C16.0729 5.79 16.3129 5.55 16.3129 5.25Z"
              fill="white"
            />
            <path
              d="M9.5625 11.0621H9.7875C10.08 11.0621 10.3125 10.7996 10.3125 10.4771C10.3125 10.0721 10.2 10.0121 9.945 9.92211L9.5625 9.78711V11.0621Z"
              fill="white"
            />
            <path
              d="M15.78 5.805C15.7725 5.805 15.765 5.8125 15.75 5.8125H12.75C12.675 5.8125 12.6075 5.7975 12.5325 5.7675C12.3975 5.7075 12.285 5.6025 12.225 5.46C12.2025 5.3925 12.1875 5.325 12.1875 5.25V2.25C12.1875 2.2425 12.195 2.235 12.195 2.22C11.22 1.7625 10.14 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 7.86 16.2375 6.78 15.78 5.805ZM10.3125 8.865C10.7925 9.03 11.4375 9.3825 11.4375 10.485C11.4375 11.4225 10.695 12.195 9.7875 12.195H9.5625V12.3825C9.5625 12.69 9.3075 12.945 9 12.945C8.6925 12.945 8.4375 12.69 8.4375 12.3825V12.195H8.3775C7.38 12.195 6.5625 11.355 6.5625 10.32C6.5625 10.005 6.8175 9.75 7.125 9.75C7.4325 9.75 7.6875 10.005 7.6875 10.3125C7.6875 10.725 7.995 11.0625 8.3775 11.0625H8.4375V9.3975L7.6875 9.135C7.2075 8.97 6.5625 8.6175 6.5625 7.515C6.5625 6.5775 7.305 5.805 8.2125 5.805H8.4375V5.625C8.4375 5.3175 8.6925 5.0625 9 5.0625C9.3075 5.0625 9.5625 5.3175 9.5625 5.625V5.8125H9.6225C10.62 5.8125 11.4375 6.6525 11.4375 7.6875C11.4375 7.995 11.1825 8.25 10.875 8.25C10.5675 8.25 10.3125 7.995 10.3125 7.6875C10.3125 7.275 10.005 6.9375 9.6225 6.9375H9.5625V8.6025L10.3125 8.865Z"
              fill="white"
            />
            <path
              d="M7.6875 7.5225C7.6875 7.9275 7.8 7.9875 8.055 8.0775L8.4375 8.2125V6.9375H8.2125C7.9275 6.9375 7.6875 7.2 7.6875 7.5225Z"
              fill="white"
            />
          </svg>
          <span class="font-w-600 font-s-13 text-color-white pr-2"
            >واریز به کیف پول</span
          >
        </button>
        <button
          data-toggle="modal"
          data-target="#depositModal"
          class="border-r-10 bg-danger py-2 px-3"
          v-if="transactions.data.length != 0"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.6875 7.5225C7.6875 7.9275 7.8 7.9875 8.055 8.0775L8.4375 8.2125V6.9375H8.2125C7.9275 6.9375 7.6875 7.2 7.6875 7.5225Z"
              fill="white"
            />
            <path
              d="M9.5625 11.0621H9.7875C10.08 11.0621 10.3125 10.7996 10.3125 10.4771C10.3125 10.0721 10.2 10.0121 9.945 9.92211L9.5625 9.78711V11.0621Z"
              fill="white"
            />
            <path
              d="M14.685 4.11L13.1475 5.6475C13.035 5.76 12.8925 5.8125 12.75 5.8125C12.6075 5.8125 12.465 5.76 12.3525 5.6475C12.135 5.43 12.135 5.07 12.3525 4.8525L13.89 3.315C12.57 2.19 10.8675 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 7.1325 15.81 5.43 14.685 4.11ZM10.3125 8.865C10.7925 9.0375 11.4375 9.3825 11.4375 10.485C11.4375 11.4225 10.695 12.195 9.7875 12.195H9.5625V12.3825C9.5625 12.69 9.3075 12.945 9 12.945C8.6925 12.945 8.4375 12.69 8.4375 12.3825V12.195H8.3775C7.38 12.195 6.5625 11.355 6.5625 10.32C6.5625 10.005 6.8175 9.75 7.125 9.75C7.4325 9.75 7.6875 10.005 7.6875 10.3125C7.6875 10.725 7.995 11.0625 8.3775 11.0625H8.4375V9.3975L7.6875 9.135C7.2075 8.9625 6.5625 8.6175 6.5625 7.515C6.5625 6.5775 7.305 5.805 8.2125 5.805H8.4375V5.625C8.4375 5.3175 8.6925 5.0625 9 5.0625C9.3075 5.0625 9.5625 5.3175 9.5625 5.625V5.8125H9.6225C10.62 5.8125 11.4375 6.6525 11.4375 7.6875C11.4375 7.995 11.1825 8.25 10.875 8.25C10.5675 8.25 10.3125 7.995 10.3125 7.6875C10.3125 7.275 10.005 6.9375 9.6225 6.9375H9.5625V8.6025L10.3125 8.865Z"
              fill="white"
            />
            <path
              d="M17.0175 1.2825C16.9575 1.1475 16.8525 1.035 16.71 0.975C16.6425 0.9525 16.575 0.9375 16.5 0.9375H13.5C13.1925 0.9375 12.9375 1.1925 12.9375 1.5C12.9375 1.8075 13.1925 2.0625 13.5 2.0625H15.1425L13.89 3.315C14.175 3.5625 14.4375 3.825 14.685 4.11L15.9375 2.8575V4.5C15.9375 4.8075 16.1925 5.0625 16.5 5.0625C16.8075 5.0625 17.0625 4.8075 17.0625 4.5V1.5C17.0625 1.425 17.0475 1.3575 17.0175 1.2825Z"
              fill="white"
            />
          </svg>
          <span class="font-w-600 font-s-13 text-color-white pr-2"
            >برداشت از کیف پول</span
          >
        </button>
      </div>
    </div>
    <b-skeleton-table
      v-if="status"
      :rows="5"
      :columns="4"
      :table-props="{ bordered: false, striped: false }"
    ></b-skeleton-table>
    <div v-else id="walletTable">
      <table class="table">
        <template v-if="transactions.data.length != 0">
          <thead>
            <tr id="trHeadWalletTabel" class="text-color-444 fontsize-small">
              <th class="hideIn768" scope="col">شناسه</th>
              <th scope="col">نوع تراکنش</th>
              <th scope="col">تاریخ تراکنش</th>
              <th scope="col">مبلغ(تومان)</th>
              <th scope="col">وضعیت</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="transaction in transactions.data"
              class="trHover"
              :key="transaction.id"
            >
              <th scope="row">
                {{ transaction.id }}
              </th>
              <td scope="row">
                <span
                  class="badge text-white"
                  :class="{
                    'badge-primary': transaction.type == 'deposit',
                    'badge-danger': transaction.type != 'deposit',
                  }"
                >
                  {{ transaction.type == "deposit" ? "واریزی  " : "برداشت " }}
                </span>
              </td>
              <td style="word-spacing: 3px">
                {{ moment(transaction.created_at).format("HH:mm YYYY/MM/DD") }}
              </td>
              <td>
                {{ transaction.amount.replace("-", "") | price }}
              </td>
              <td>
                <span
                  class="badge"
                  :class="{
                    'badge-success': transaction.confirmed == true,
                    'badge-danger': transaction.confirmed == false,
                  }"
                >
                  {{ transaction.confirmed == true ? "موفق" : "ناموفق" }}
                </span>
              </td>
              <td>
                {{
                  transaction.type == "deposit"
                    ? " "
                    : transaction.meta.description
                }}
              </td>
            </tr>
          </tbody>
        </template>
        <div class="w-100 text-center py-5" v-else>
          <svg
            width="65"
            height="65"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.042 61.6143H18.9587C9.64199 61.6143 3.38574 55.358 3.38574 46.0413V32.4997C3.38574 24.158 8.53158 18.1184 16.5212 17.1164C17.2795 17.008 18.1191 16.9268 18.9587 16.9268H46.042C46.692 16.9268 47.5316 16.9538 48.3982 17.0893C56.3878 18.0101 61.6149 24.0768 61.6149 32.4997V46.0413C61.6149 55.358 55.3587 61.6143 46.042 61.6143ZM18.9587 20.9893C18.3087 20.9893 17.6857 21.0434 17.0628 21.1246C11.1045 21.883 7.44824 26.2163 7.44824 32.4997V46.0413C7.44824 53.0288 11.9712 57.5518 18.9587 57.5518H46.042C53.0295 57.5518 57.5524 53.0288 57.5524 46.0413V32.4997C57.5524 26.1622 53.842 21.8018 47.8295 21.0976C47.1795 20.9893 46.6107 20.9893 46.042 20.9893H18.9587Z"
              fill="#C4C1C1"
            />
            <path
              d="M16.7651 21.1525C16.1151 21.1525 15.5193 20.8546 15.113 20.3129C14.6526 19.69 14.5985 18.8775 14.9505 18.2004C15.411 17.2796 16.061 16.3858 16.9005 15.5733L25.7026 6.74414C30.1985 2.27539 37.511 2.27539 42.0068 6.74414L46.7464 11.5379C48.7505 13.515 49.9693 16.1692 50.1047 18.9859C50.1318 19.6088 49.888 20.2045 49.4276 20.6108C48.9672 21.017 48.3443 21.2067 47.7485 21.0984C47.2068 21.0171 46.638 20.99 46.0422 20.99H18.9589C18.3089 20.99 17.686 21.0441 17.063 21.1254C16.9818 21.1525 16.8735 21.1525 16.7651 21.1525ZM21.288 16.9275H45.5547C45.2026 16.0067 44.6339 15.1671 43.8755 14.4088L39.1089 9.58794C36.211 6.71711 31.4714 6.71711 28.5464 9.58794L21.288 16.9275Z"
              fill="#C4C1C1"
            />
            <path
              d="M59.5837 46.7191H51.4587C47.342 46.7191 44.0107 43.3878 44.0107 39.2712C44.0107 35.1545 47.342 31.8232 51.4587 31.8232H59.5837C60.6941 31.8232 61.6149 32.7441 61.6149 33.8545C61.6149 34.9649 60.6941 35.8857 59.5837 35.8857H51.4587C49.5899 35.8857 48.0732 37.4024 48.0732 39.2712C48.0732 41.1399 49.5899 42.6566 51.4587 42.6566H59.5837C60.6941 42.6566 61.6149 43.5774 61.6149 44.6878C61.6149 45.7982 60.6941 46.7191 59.5837 46.7191Z"
              fill="#C4C1C1"
            />
          </svg>

          <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
            اطلاعاتی در دسترس نمی باشد
          </h5>
        </div>
      </table>
    </div>
    <section
      id="mainPaginationBlog"
      v-if="transactions && transactions.last_page > 1"
      class="weblog-list-pagination text-center my-4 p-2 bg-color-fa"
    >
      <section
        v-if="transactions"
        id="listPagination"
        class="list-pagination weblog-list-pagination text-center my-4 py-2"
      >
        <pagination
          :limit="1"
          :data="transactions"
          @pagination-change-page="changePage"
          :disabled="status"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <ZPrevSvg />
          </span>
          <span slot="next-nav">
            <ZNextSvg />
          </span>
        </pagination>
      </section>
      <!-- <pagination :data="blogs.posts.links" :router="true" @pagination-change-page="changePage"></pagination> -->
    </section>
    <Deposit />
  </section>
</template>
<script>
import paginationMixin from "@/libraries/mixins/paginationMixin";
import Deposit from "@/parts/Front/components/panel/Wallet/DepositWallet.vue";
import ZPrevSvg from "@/parts/Front/components/shared/ZPrevSvg";
import ZNextSvg from "@/parts/Front/components/shared/ZNextSvg";
import LineGrow from "@/parts/Front/components/shared/LineGrow";
import { BSkeletonTable } from "bootstrap-vue";
import WalletIcon from "@/parts/Front/components/Icon/panelIcons/Wallet.vue";
export default {
  mixins: [paginationMixin],
  props: { tab: { Number } },
  components: {
    LineGrow,
    ZNextSvg,
    ZPrevSvg,
    Deposit,
    BSkeletonTable,
    WalletIcon,
  },
  computed: {
    transactions() {
      return this.$store.getters["front/getTransaction"];
    },
    status() {
      return this.$store.getters["front/getTransactionStatus"];
    },
  },
  created() {
    if (this.transactions == null) {
      this.$store.dispatch(
        "front/getTransactionFromServer",
        this.$route.query.page != undefined ? this.$route.query.page : "1"
      );
    }
  },
  methods: {},
  watch: {
    "$route.query.page": {
      handler: function (val) {
        let page = val;
        if (this.allow)
          this.$store.dispatch("front/getTransactionFromServer", page);
      },
      immediate: true,
    },
  },
  data() {
    return {
      allow: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.allow = true;
    }, 5000);
  },
};
</script>
<style scoped>
#headWalletTabel {
  border-top: solid transparent;
}
.walletOptionBtn {
  margin-bottom: 5px;
  background-color: #35a80b;
  color: white;
  border-radius: 7px;
  padding: 5px 10px;
  position: absolute;
  top: 10px;
  right: 30px;
}
#walletTable {
  width: 100%;
  overflow: auto;
}
#trHeadWalletTabel {
  border-top: solid transparent;
}
</style>
